import {
  call,
  cancel,
  delay,
  fork,
  put,
  take,
  takeLatest,
} from 'redux-saga/effects';
import {
  changeUserEmail as changeUserEmailAPI,
  getChangeUserEmailLogs as getChangeUserEmailLogsAPI,
} from 'api/changeUserEmail/changeUserEmail';
import {
  changeUserEmailSuccess,
  changeUserEmailFailure,
  setChangeUserEmailLoading,
  clearChangeUserEmailLogErrors,
  resetChangeUserEmailLogData,
  setChangeUserEmailLogData,
  setChangeUserEmailLogErrors,
  setChangeUserEmailLogIsLoading,
  setChangeUserEmailLogModalShown,
  setChangeUserEmailLogPage,
} from 'state/changeUserEmail/actions';
import * as toastActions from 'state/toast/actions';
import {
  CHANGE_USER_EMAIL,
  CHANGE_USER_EMAIL_DO_SHOW_LOG,
  CHANGE_USER_EMAIL_LOG_CHANGE_PAGE,
  CHANGE_USER_EMAIL_LOG_SET_SHOWN,
} from 'state/actionTypes';

function* changeUserEmailSaga(action) {
  try {
    yield put(setChangeUserEmailLoading(true));
    const response = yield call(changeUserEmailAPI, action.payload);
    yield put(changeUserEmailSuccess(response.data));
    yield put(toastActions.successMessage('User email changed successfully'));
  } catch (error) {
    yield put(changeUserEmailFailure(error.message));
    yield put(
      toastActions.errorMessage('Failed to change user email', error.message)
    );
  } finally {
    yield put(setChangeUserEmailLoading(false));
  }
}

function* logModalTask() {
  while (true) {
    const { page } = (yield take(CHANGE_USER_EMAIL_LOG_CHANGE_PAGE)).payload;
    yield put(setChangeUserEmailLogIsLoading(true));
    yield put(clearChangeUserEmailLogErrors());
    yield put(resetChangeUserEmailLogData());
    try {
      const {
        data: {
          data: { internal_tools_activities: activities },
          paging,
        },
      } = yield call(getChangeUserEmailLogsAPI, page, 20);
      yield put(setChangeUserEmailLogData(activities, paging));
    } catch (e) {
      yield put(setChangeUserEmailLogErrors([e.message]));
    } finally {
      yield put(setChangeUserEmailLogIsLoading(false));
    }
  }
}

export function* doShowChangeUserEmailLogs() {
  const task = yield fork(logModalTask);
  yield delay(30);
  yield put(setChangeUserEmailLogPage(1));
  yield put(setChangeUserEmailLogModalShown(true));
  let closeModalRequest;
  do {
    closeModalRequest = (yield take(CHANGE_USER_EMAIL_LOG_SET_SHOWN)).payload;
  } while (closeModalRequest.shown);
  yield cancel(task);
}

export default function* changeUserEmailRootSaga() {
  yield takeLatest(CHANGE_USER_EMAIL, changeUserEmailSaga);
  yield takeLatest(CHANGE_USER_EMAIL_DO_SHOW_LOG, doShowChangeUserEmailLogs);
}
